// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MailList_wrap__1tL0S","list":"MailList_list__2pTbR"};